import { Clear } from '@mui/icons-material'
import {
	Box,
	DialogContent,
	DialogTitle,
	IconButton,
	Theme,
} from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { px } from 'csx'
import React from 'react'

type KeyboardShortcutDialogProps = {
	onClose: () => void
}

type KeyboardShortcut = {
	keyboardKeys: string[]
	command: string
}

type KeyDisplayProps = {
	keyboardKeys: string[]
}

export const KeyboardShortcutDialog: React.FC<KeyboardShortcutDialogProps> = (
	props: KeyboardShortcutDialogProps,
) => {
	const styles = useStyles()

	const shortcuts: KeyboardShortcut[] = [
		{
			keyboardKeys: ['ctrl', 'h'],
			command: 'Fit to page',
		},
		{
			keyboardKeys: ['shift', '+'],
			command: 'Fit to field',
		},
		{
			keyboardKeys: ['ctrl', '+'],
			command: 'Zoom in',
		},
		{
			keyboardKeys: ['ctrl', '-'],
			command: 'Zoom out',
		},
		{
			keyboardKeys: ['ctrl', '↑'],
			command: 'Pan up',
		},
		{
			keyboardKeys: ['ctrl', '↓'],
			command: 'Pan down',
		},
		{
			keyboardKeys: ['ctrl', '←'],
			command: 'Pan left',
		},
		{
			keyboardKeys: ['ctrl', '→'],
			command: 'Pan right',
		},
		{
			keyboardKeys: ['ctrl', '<'],
			command: 'Previous page',
		},
		{
			keyboardKeys: ['ctrl', '>'],
			command: 'Next page',
		},
		{
			keyboardKeys: ['tab'],
			command: 'Next field',
		},
		{
			keyboardKeys: ['enter'],
			command: 'Next low confidence field',
		},
		{
			keyboardKeys: ['shift', 'tab'],
			command: 'Previous field',
		},
		{
			keyboardKeys: ['space'],
			command: 'Check or uncheck checkbox',
		},
		{
			keyboardKeys: ['ctrl', 'shift', 'enter'],
			command: 'Submit',
		},
	]

	return (
		<>
			<DialogTitle>
				<Box display="flex" justifyContent="space-between" alignItems="center">
					Keyboard Shortcuts
					<IconButton onClick={props.onClose} color="primary">
						<Clear />
					</IconButton>
				</Box>
			</DialogTitle>
			<DialogContent>
				<div className={styles.grid}>
					<div>
						{shortcuts.map((shortcut, i) => {
							return (
								<div key={i} className={styles.command}>
									{shortcut.command}
								</div>
							)
						})}
					</div>
					<div>
						{shortcuts.map((shortcut, i) => {
							return <KeyDisplay key={i} keyboardKeys={shortcut.keyboardKeys} />
						})}
					</div>
				</div>
			</DialogContent>
		</>
	)
}

const KeyDisplay: React.FC<KeyDisplayProps> = ({
	keyboardKeys,
}: KeyDisplayProps) => {
	const styles = useStyles()

	return (
		<div className={styles.keys}>
			{keyboardKeys.map((key, i) => {
				return (
					<div key={i} className={styles.key}>
						{key}
					</div>
				)
			})}
		</div>
	)
}

const useStyles = makeStyles((theme: Theme) => ({
	grid: {
		display: 'grid',
		gridTemplateColumns: '1fr 1fr',
	},

	command: {
		padding: px(13),
		marginRight: px(20),
	},

	keys: {
		display: 'flex',
		flexDirection: 'row',
		padding: px(10),
	},

	key: {
		background: theme.palette.primary.contrastText,
		color: theme.palette.primary.dark,
		borderRadius: px(4),
		display: 'inline-flex',
		fontWeight: 600,
		marginRight: px(3),
		paddingLeft: px(10),
		paddingRight: px(10),
		borderStyle: 'outset',
	},
}))
